import { useState } from "react";
import { Radio, Check, MapPin } from "lucide-react";
import { MastKarte } from "./MastKarte";

// Auswahl der Ziel-Masten: "Alle" oder einzelne. selected = [] bedeutet alle.
export function MastAuswahl({ devices, selected, onChange, compact = false }) {
  const alle = selected.length === 0;
  const [karte, setKarte] = useState(false);
  const toggle = (id) => {
    // aus "Alle" heraus: Antippen waehlt genau diesen Mast (bei nur einem Mast bleibt es "Alle" = derselbe Mast)
    if (alle) { onChange(devices.length > 1 ? [id] : []); return; }
    const next = selected.includes(id) ? selected.filter(x => x !== id) : [...selected, id];
    // letzten abgewaehlt oder alle gewaehlt -> wieder "Alle Masten"
    onChange(next.length === 0 || next.length === devices.length ? [] : next);
  };
  // mitgesteuert ueber "Alle" = hell hervorgehoben, einzeln gewaehlt = kraeftig
  const chip = (on, ueberAlle = false) => `inline-flex items-center gap-1 px-2.5 py-1.5 rounded-full border text-xs font-medium transition-colors ${on ? "bg-fuchsia-600 border-fuchsia-600 text-white" : ueberAlle ? "bg-fuchsia-50 border-fuchsia-300 text-fuchsia-800 hover:bg-fuchsia-100" : "bg-white border-gray-200 text-gray-600 hover:border-fuchsia-300"}`;
  return (
    <div className="flex flex-wrap items-center gap-1.5" data-testid="mast-auswahl">
      <Radio className="w-4 h-4 text-gray-400 shrink-0" />
      {!compact && <span className="text-xs text-gray-500 mr-1">Ziel:</span>}
      {devices.length === 0 && <span className="text-xs text-gray-400">Aktuell kein Mast zugewiesen.</span>}
      {devices.length > 0 && (
        <button type="button" onClick={() => onChange([])} className={chip(alle)} data-testid="mast-auswahl-alle">
          {alle && <Check className="w-3 h-3" />} Alle Masten ({devices.length})
        </button>
      )}
      {devices.length > 0 && (
        <button type="button" onClick={() => setKarte(true)} title="Masten auf der Karte auswählen"
          className="inline-flex items-center gap-1 px-2.5 py-1.5 rounded-full border text-xs font-semibold bg-white border-fuchsia-300 text-fuchsia-700 hover:bg-fuchsia-50" data-testid="mast-auswahl-gps">
          <MapPin className="w-3.5 h-3.5" /> GPS
        </button>
      )}
      {karte && <MastKarte devices={devices} selected={selected} onClose={(neu) => { setKarte(false); if (neu) onChange(neu); }} />}
      {devices.map(d => {
        const on = alle || selected.includes(d.id);
        const dot = d.pi?.playing ? "bg-fuchsia-300" : d.pi?.online ? "bg-emerald-400" : "bg-gray-300";
        return (
          <button key={d.id} type="button" onClick={() => toggle(d.id)} className={chip(on && !alle, alle)} title={(alle && devices.length > 1 ? "Antippen: nur diesen Mast wählen · " : "") + (d.pi?.playing ? `spielt ${d.pi.playing.label || d.pi.playing.file}${d.pi.playing.loop ? " (Schleife)" : ""}` : d.pi?.online ? "bereit" : "offline")} data-testid={`mast-auswahl-${d.serial_number}`}>
            {on ? <Check className="w-3 h-3" /> : <span className={`w-2 h-2 rounded-full ${dot}`} />}
            {on && <span className={`w-2 h-2 rounded-full ${dot}`} />}
            {d.name}
            {d.pi?.playing && <span className="opacity-80">· spielt{d.pi.playing.loop ? " ∞" : ""}</span>}
            {!d.pi?.online && <span className="opacity-70">· offline</span>}
          </button>
        );
      })}
    </div>
  );
}
